import JSZip from 'jszip';

const imageExtensions: { [mime: string]: string } = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
};

export const extensionForMime = (mime: string, allowPdf: boolean) => {
  if (imageExtensions[mime]) return imageExtensions[mime];
  if (allowPdf && mime === 'application/pdf') return 'pdf';
  throw new Error('Unsupported document format');
};

export const activationDocumentName = (field: string, mime: string, ownerIndex?: number) => {
  const extension = extensionForMime(mime, field === 'bank_statement' || ownerIndex !== undefined);
  return ownerIndex === undefined
    ? `${field}.${extension}`
    : `beneficial_owner_${ownerIndex + 1}_id_proof.${extension}`;
};

export const addActivationDocument = (
  zip: JSZip,
  field: string,
  file: Blob,
  ownerIndex?: number,
) => {
  const name = activationDocumentName(field, file.type, ownerIndex);
  zip.file(name, file);
  return name;
};
